const appSettings = {
  maxQuantityPerItem: 10,
};

export default appSettings;
